import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EntityComponent } from './components/entity/entity.component';
import { FilterDialogComponent } from './components/filter-dialog/filter-dialog.component';
import { EntityService } from './services/entity.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { TokenAuthComponent } from './components/token-auth/token-auth.component';
import { AddHeaderInterceptor } from './components/interceptor/header.interceptor';
import { RequestUtilityService } from './services/utility/request-utility.service';
import { AddAnnotationComponent } from './components/add-annotation/add-annotation.component';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { LoginDialogueComponent } from './components/login-dialogue/login-dialogue.component';

// Material modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    AppComponent,
    TokenAuthComponent,
    LoginComponent,
    LoginDialogueComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    // Material modules
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    // Standalone components
    EntityComponent,
    FilterDialogComponent,
    AddAnnotationComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AddHeaderInterceptor,
      multi: true
    },
    RequestUtilityService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    EntityService,
    MatDialogModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
